<template>
  <sfs-base-table
    :key="tableKey"
    :data-provider="$analyticsAPI.getWorkOrdersRevenueReport"
    provider-key="records"
    :columns="columns"
    :filters="filters"
    :current-page="currentPage"
    :per-page="perPage"
    :show-per-page="showPerPage"
    @total-rows-changed="(totalRows) => $emit('total-rows-changed', totalRows)"
  >
    <template #cell(period)="data">
      <div>
        {{ data.item.group }}
      </div>
    </template>
    <template #cell(revenue)="data">
      <money-format
        :value="data.item.total_revenue"
        subunits-value
      />
    </template>
    <template #cell(work_orders)="data">
      <div>
        {{ data.item.total_work_orders | numberWithDelimeter }}
      </div>
    </template>
    <template #cell(total_cost)="data">
      <div>
        <money-format
          :value="data.item.total_cost"
          subunits-value
        />
      </div>
    </template>
    <template #cell(profit)="data">
      <div>
        <money-format
          :value="data.item.profit"
          subunits-value
        />
      </div>
    </template>
    <template #cell(margin)="data">
      <div>
        {{ `${Math.floor(data.item.margin)}%` }}
      </div>
    </template>
  </sfs-base-table>
</template>

<script>
import translationMixin from '@/mixins/translationMixin';
import tablePropsMixin from '@/mixins/tablePropsMixin';
import { WORK_ORDER_REVENUE_REPORT_TABLE_COLUMNS } from '@/constants/reports';

export default {
  name: 'RevenueReportTable',
  mixins: [tablePropsMixin, translationMixin],
  props: {
    columns: {
      type: Array,
      default: WORK_ORDER_REVENUE_REPORT_TABLE_COLUMNS,
    },
  },
};
</script>
